import type { HelpFile } from '../../types/help'
import { ServiceAccountsTestIds } from '../../../testids/ServiceAccountsTestIds'

export const serviceAccountsHelp: HelpFile = {
  docPage: '/docs/admin/service-accounts',
  texts: {
    [ServiceAccountsTestIds.serviceAccountsList]:
      'Nicht-menschliche Authentifizierungsidentitäten für Automatisierung, Skripte und Integrationen, die diese Anwendung über API-Schlüssel aufrufen.',
    [ServiceAccountsTestIds.btnCreateServiceAccount]:
      'Ein neues Servicekonto anlegen. Das Konto startet ohne API-Schlüssel — erzeugen Sie einen aus der Detailseite, sobald es existiert.',
    [ServiceAccountsTestIds.btnCreateEmpty]: null,
    [ServiceAccountsTestIds.colName]:
      'Anzeigename des Servicekontos — wird in Audit-Logs und API-Schlüssel-Headern verwendet.',
    [ServiceAccountsTestIds.colActiveKeys]:
      'Anzahl der derzeit aktiven API-Schlüssel für dieses Konto. Inaktive Konten zeigen immer 0.',
    [ServiceAccountsTestIds.colStatus]:
      'Aktive Servicekonten können sich mit API-Schlüsseln authentifizieren; eine Deaktivierung widerruft alle Schlüssel sofort.',
    [ServiceAccountsTestIds.colCreated]:
      'Datum, an dem das Servicekonto angelegt wurde.',
    [ServiceAccountsTestIds.createDialogTitle]: null,
    [ServiceAccountsTestIds.createForm]: null,
    [ServiceAccountsTestIds.createInputName]:
      'Eindeutiger, menschenlesbarer Name für das Servicekonto (1–100 Zeichen).',
    [ServiceAccountsTestIds.createInputDescription]:
      'Optionale Freitextbeschreibung (bis zu 500 Zeichen), die den Verwendungszweck des Kontos beschreibt.',
    [ServiceAccountsTestIds.emptyState]: null,
  },
}
